import _ from "underscore";
import moment from "moment";
import { ScoringCardsClient } from "@topline/services/apiService";

export class ProjectDataService {
    static componentName = "ProjectDataService";
    static $inject = [ScoringCardsClient.componentName];

    constructor(protected apiClient: ScoringCardsClient) {}

    getProjectData = (uid: string) => {
        return this.apiClient.getProjectData(uid).then(data => {
            if (data && data.projectForecast && data.projectForecast.length > 0) {

                const minForecast = _.min(data.projectForecast, f => f.year);
                const maxForecast = _.max(data.projectForecast, f => f.year);

                if(typeof minForecast === "number" || typeof maxForecast === "number") {
                    return data;
                }

                data.forecastStartDate = moment.utc(`${minForecast.year}-01`, "YYYY-MM").toDate();
                data.forecastEndDate = moment.utc(`${maxForecast.year}-12`, "YYYY-MM").toDate();
            }
            return data;
        });
    };
}

angular.module("topline.modules").service(ProjectDataService.componentName, ProjectDataService);
